import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { fireConfetti, haptic } from "@/lib/celebrate";
import { popCredits } from "@/components/CreditPop";

const FLAG_KEY = (uid) => `welcome_celebrated_${uid}`;
const FRESH_WINDOW_MS = 24 * 60 * 60 * 1000; // 24h

export const WelcomeCelebration = () => {
  const { user } = useAuth();
  const fired = useRef(false);

  useEffect(() => {
    if (!user || fired.current) return;
    if (localStorage.getItem(FLAG_KEY(user.id))) return;

    // Only celebrate brand-new accounts (created in last 24h)
    if (user.created_at) {
      const age = Date.now() - new Date(user.created_at).getTime();
      if (age > FRESH_WINDOW_MS) {
        // Account too old, mark as celebrated to avoid future runs
        localStorage.setItem(FLAG_KEY(user.id), "1");
        return;
      }
    }

    // Wait for onboarding to be dismissed before celebrating
    const onboardingDone = localStorage.getItem(`onboarding_done_${user.id}`);
    if (!onboardingDone) {
      // Poll every 1s until onboarding closed
      const interval = setInterval(() => {
        if (localStorage.getItem(`onboarding_done_${user.id}`)) {
          clearInterval(interval);
          triggerCelebration();
        }
      }, 1000);
      return () => clearInterval(interval);
    }

    triggerCelebration();

    function triggerCelebration() {
      if (fired.current) return;
      fired.current = true;
      localStorage.setItem(FLAG_KEY(user.id), "1");

      setTimeout(() => {
        fireConfetti("big");
        haptic(80);
        popCredits(100, "credits");
        toast.success(
          `Bienvenue sur ReallyFan ${user.pseudo || ""} ! 100 credits offerts pour demarrer.`,
          { duration: 6000 }
        );
      }, 600);
    }
  }, [user]);

  return null;
};
